import { Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "@angular/common";

@Pipe({
  name: 'dateTimeToDescription',
  standalone: false
})
export class DateTimeToDescriptionPipe implements PipeTransform {
  transform(value: Date): string {
    if (!value) {
      return '';
    }

    // Format the date as "14 juli 2024"
    const formattedDate = formatDate(value, 'd MMMM yyyy', 'nl-NL');

    // Format the time as "15:34 uur"
    const formattedTime = formatDate(value, 'HH:mm', 'nl-NL');

    return `${formattedDate} • ${formattedTime}`;
  }
}